module.exports = __webpack_public_path__ + "img/20191007155814360截图20191007145154847.2b8994ee.jpg";